import QInputNumber from './src/QInputNumber.vue';

/* istanbul ignore next */
QInputNumber.install = function(Vue) {
  Vue.component(QInputNumber.name, QInputNumber);
};

export default QInputNumber;
